var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add_new custom-btn-wrapper rounded-pill"},[_c('router-link',{staticClass:"btn btn-primary border-0 fw-bold text-white waves-effect waves-light primary-button rounded-pill custom-link-btn",attrs:{"to":_vm.linkTo}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }